import Swiper, { Zoom, Pagination, Navigation, Scrollbar, Keyboard, Mousewheel } from 'swiper';
const utils = require('../utils');

/**
 * Updates the fraction display on the Swiper carousel when the slide changes.
 *
 * This function is called as a callback for the `slideChange` event of the Swiper instance.
 * It updates the text content of the `.swiper-fraction` element to display the current slide number
 * and the total number of slides. It also triggers lazy loading for the image on the current slide.
 *
 * @param {Object} swiper - The Swiper instance.
 * @returns {void}
 */
const showFractionOnSlideChange = (swiper) => {
    const $slides = $('.swiper-slide', swiper.$el);
    const slideCount = $slides.length;
    const currentIndex = swiper.realIndex + 1;
    const fraction = $('.swiper-fraction', swiper.$el);
    fraction.text(currentIndex + ' / ' + slideCount);
    utils.lazyLoadImage($('.instance-' + currentIndex));
};

/**
     *
     Enable Swiper
     * @param {Object} elem - Element
     * @returns {Object} swiper
     */
const createSwiperCarousel = ($elem, options = {}) => {
    // Default Swiper options
    var defaultOptions = {
        direction: 'horizontal',
        roundLengths: true,
        modules: [Zoom, Pagination, Navigation, Scrollbar, Keyboard, Mousewheel],
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        zoom: {
            maxRatio: 3,
            minRatio: 1
        },
        on: {
            slideChange: () => {}
        }
    };

    const swiperOptions = $.extend(true, {}, defaultOptions, options);

        // destroy existing sliders
    $elem.each((index, swiperElem) => {
        $(swiperElem).removeClass('show-fraction');
        if (swiperElem.swiper) {
            swiperElem.swiper.destroy();
        }
    });


    $elem.each((i, swiperElem) => {
        if (swiperElem.swiper) {
            swiperElem.swiper.destroy();
        }

        const $slides = $('.swiper-slide', swiperElem);
        const slideCount = $slides.length;
        $(swiperElem).addClass('instance-' + i);


        if (slideCount > 1) {
            $(swiperElem).addClass('show-fraction');
        }


        const swiper = new Swiper(swiperElem, swiperOptions);
        swiperOptions.on.slideChange(swiper);

        if (swiperOptions.pagination) {
            setTimeout(() => {
                if (swiper.pagination) {
                    swiper.pagination.render();
                    swiper.pagination.update();
                }
            }, 200);
        }

        return swiper;
    });
};

export default {
    createSwiperCarousel,
    showFractionOnSlideChange
};
